export function isUnauthorizedError(error) {
  return Boolean(error && error.response && error.response.status === 401);
}